const DATE_TIME_FORMAT = "Y-MM-DD";
const DATE_TIME_TEXT_FORMAT = "Y年MM月DD日";
const DATE_TIMESTAMP_FORMAT = "Y-MM-DD h:mm:ss";
const DATETIME_FORMAT_FILE_NAME = "Y-MM-DD_Hmmss";
const DATETIME_FORMAT_PDF_FILE_NAME = "Y-MM-DD_Hmm";
const DATE_PICKER_FORMAT = "Y-m-d";
const DATE_TIME_CHECKING_FORMAT = "YMMDDHms";
const DATE_MOMENT_FORMAT = "YYYY-MM-DD";
const DATE_SLASH_FORMAT = "YYYY/MM/DD";
const ROLE_ADMIN = "admin";
const ROLE_CUSTOMER = "customer";
const ROLE_ADMIN_CUSTOMER = "admin-customer";
const ADMIN_TYPE = "admin";
const CUSTOMER_TYPE = "customer";
const HTTP_STATUS_OK = 200;
const HTTP_STATUS_CREATED = 201;
const HTTP_STATUS_VALIDATE_FAILURE = 422;
const HTTP_STATUS_NO_CONTENT = 204;
const ITEM_STATUS_DELETED = '取消';
const MAX_PRICE = 9999999999;
const STOP_PRODUCT = ["3", "7", "8", "9"];
export {
  DATE_TIME_FORMAT,
  ROLE_ADMIN,
  ROLE_CUSTOMER,
  ROLE_ADMIN_CUSTOMER,
  DATE_PICKER_FORMAT,
  DATE_TIMESTAMP_FORMAT,
  DATE_TIME_CHECKING_FORMAT,
  DATETIME_FORMAT_FILE_NAME,
  DATETIME_FORMAT_PDF_FILE_NAME,
  DATE_MOMENT_FORMAT,
  DATE_SLASH_FORMAT,
  ADMIN_TYPE,
  CUSTOMER_TYPE,
  DATE_TIME_TEXT_FORMAT,
  HTTP_STATUS_OK,
  HTTP_STATUS_CREATED,
  HTTP_STATUS_VALIDATE_FAILURE,
  HTTP_STATUS_NO_CONTENT,
  ITEM_STATUS_DELETED,
  MAX_PRICE,
  STOP_PRODUCT,
};
